import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { ViewListprofileCommercial } from './ViewListprofileCommercial';
import { Dialog } from 'primereact/dialog';


export const ModalViewProfilesCommercial = (props) => {

    const {

        modal3,toggle3,modalTitle,method,listCommercial
    } = props;

    return (
        <Dialog
            header={modalTitle}
            visible={modal3}
            onHide={toggle3}
                        headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}            modal
            closable
            dismissableMask={false} 
            blockScroll  
            className="small-dialog"

        >
            {
                method === "list"
                ?
                    <ViewListprofileCommercial {...{ toggle3, listCommercial }} />
                :
                    null
            }
        </Dialog>
    )
}
